// extracted by mini-css-extract-plugin
export default {"pageFrame":"pageFrame-JdpSN","header":"header-wUJW4","goBackLabel":"goBackLabel-hu8kP","title":"title-cjoQS","subtitle":"subtitle-cigNg"};